module.exports = __webpack_public_path__ + "static/media/clientes.999a09a1.jpg";